import React from "react";
import Sidebar from "./Sidebar";
import { Toaster } from "sonner";
import { HelpCircle } from "lucide-react";
import WorkflowGuide, { useWorkflowGuide } from "./WorkflowGuide";
import TourOverlay from "./TourOverlay";

export default function AppShell({ title, subtitle, actions, children }) {
  const { open, setOpen } = useWorkflowGuide();
  return (
    <div className="flex min-h-screen bg-[#F9FAFB] grain-bg">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <header className="bg-white/90 backdrop-blur-md border-b border-border sticky top-0 z-40">
          <div className="px-8 py-5 flex items-end justify-between gap-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
              {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
            </div>
            <div className="flex items-center gap-2">
              {actions}
              <button
                type="button"
                onClick={() => setOpen(true)}
                className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-slate-200 bg-white text-slate-600 hover:text-[#0A4C95] hover:border-[#0A4C95] transition-colors"
                title="How Stryde Finance works"
                aria-label="Open workflow guide"
                data-testid="help-btn"
              >
                <HelpCircle className="w-4 h-4" />
              </button>
            </div>
          </div>
        </header>
        <div className="p-6 md:p-8">{children}</div>
        <Toaster richColors position="top-right" />
        <WorkflowGuide open={open} onOpenChange={setOpen} />
        <TourOverlay />
      </main>
    </div>
  );
}
